import React, {useState, useEffect} from "react";
import useStateType from "../Stores/StateStore";

const MAX_SELECTED = 2;
interface StateCompProps {
  tempSelection: string[];
  setTempSelection: (value: string[]) => void;
  displayValue: number;
  onClose?: () => void;
}

const StateComp: React.FC<StateCompProps> = ({
  tempSelection,
  setTempSelection,
  displayValue,
  onClose,
}) => {
  const stateCompValue = useStateType((s) => s.stateCompValue);
  const setStateCompValue = useStateType((s) => s.setStateCompValue);
  const stateList = useStateType((s) => s.stateList);

  const isAllBlocked = displayValue === 2 || displayValue === 3;

  const toggle = (label: string) => {
    if (isAllBlocked && label === "All") return;

    let newSelection: string[];
    if (tempSelection.includes(label)) {
      newSelection = tempSelection.filter((v) => v !== label);
    } else {
      newSelection = [...tempSelection, label];
    }
    setTempSelection(newSelection);

    if (newSelection.length === MAX_SELECTED) {
      setStateCompValue(newSelection);
      // Close menu when user makes a selection (changes from current state)
      if (
        JSON.stringify(newSelection.sort()) !==
        JSON.stringify([...stateCompValue].sort())
      ) {
        onClose?.();
      }
    }
  };

  const isDisabled = (label: string) =>
    (isAllBlocked && label === "All") ||
    (!tempSelection.includes(label) && tempSelection.length >= MAX_SELECTED);

  useEffect(() => {
    if (isAllBlocked && tempSelection.includes("All")) {
      const fallback = ["Alaska", "Alabama"];
      const haveBoth =
        stateList.includes("Alaska") && stateList.includes("Alabama");
      const replacement = haveBoth
        ? fallback
        : stateList.filter((s) => s !== "All").slice(0, 2);

      setTempSelection(replacement);
      if (replacement.length === MAX_SELECTED) {
        setStateCompValue(replacement);
      }
    }
  }, [
    isAllBlocked,
    tempSelection,
    stateList,
    setTempSelection,
    setStateCompValue,
  ]);

  return (
    <div className="flex flex-col justify-center">
      <ul>
        {stateList.map((label) => {
          const checked = tempSelection.includes(label);
          const disabled = isDisabled(label);
          return (
            <li key={label}>
              <label className="label cursor-pointer justify-start ml-2 gap-0">
                <input
                  type="checkbox"
                  className="checkbox checkbox-xs checkbox-accent checked::border-accent bg-white"
                  checked={checked}
                  onChange={() => toggle(label)}
                  disabled={disabled}
                />
                <div
                  className={`ml-2 ${
                    disabled ? "opacity-50" : "text-valmidnight"
                  }`}>
                  {label}
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default StateComp;
